import React, { useRef } from 'react';
import {
  ThemeProvider as FreemiumThemeProvider,
  UiProvider as FreemiumUiProvider,
} from 'freemium-ui';
import { ErrorBoundary } from 'react-error-boundary';
// import SurveyServProvider from 'surveyserv/SurveyServProvider';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ThemeProvider } from 'styled-components';
import Routes from './routes';
import EmptyState from './shared/components/EmptyState';
import __DevOnlyPage__ from './__devOnly__';
import AccessProvider from './access-provider';
import GlobalStyles from './reset.css';

const App = () => {
  const queryClient = useRef(
    new QueryClient({
      defaultOptions: {
        queries: {
          retry: 2,
          refetchOnWindowFocus: false,
          staleTime: 300000,
          cacheTime: 300000,
        },
      },
    }),
  );

  React.useEffect(() => {
    (window as any).freshworksOmnibar = {
      onSessionStateChanged: function callback() {
        console.log('#### freshid got disconnected ####');
        // localStorage.clear();
        window.location.href = `${window.location.origin}/freshid/logout`;
      },
    };
  }, []);

  const ErrorFallBack = () => {
    return (
      <section className="app-section">
        <EmptyState
          imgSrc="empty-state-error.svg"
          message="Oops! Something went wrong. Sorry about that! Can you please clear the browser cache, refresh the page and try again?"
        />
      </section>
    );
  };

  return (
    <ThemeProvider theme={{}}>
      <FreemiumThemeProvider globalStyle theme={{}}>
        <FreemiumUiProvider>
          <AccessProvider>
            <ErrorBoundary FallbackComponent={ErrorFallBack}>
              <QueryClientProvider client={queryClient.current}>
                {process.env.NODE_ENV === 'development' && <__DevOnlyPage__ />}
                <Routes />
              </QueryClientProvider>
            </ErrorBoundary>
          </AccessProvider>
        </FreemiumUiProvider>
      </FreemiumThemeProvider>
      <GlobalStyles />
    </ThemeProvider>
  );
};

export default App;
